<template>
  <div>
    <section class="checkout">
      <div class="container">
        <button
          v-if="tryAgain && !cartExpired"
          class="button button--primary"
          @click="goToPayment"
          data-testid="checkoutTryAgain"
        >
          Try again?
        </button>

        <button class="button button--secondary" @click="reset">
          Leave checkout
        </button>
      </div>
    </section>

    <modal-velocity v-if="velocityModal" />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ModalVelocity from './components/modal-velocity'
import { actionTypes } from '@vue/common/constants/store.types'
import { OrderStates} from '@vue/common/constants/order'
import { paymentFailedKlaviyo } from '@vue/services/klaviyo.service'

export default {
  name: 'PaymentUnsuccessful',
  components: {
    ModalVelocity
  },
  data() {
    return {
      // By default do not show button to try again
      tryAgain: false
    }
  },
  computed: {
    ...mapState({
      order: (state) => state.checkout.order,
      velocityModal: (state) => state.checkout.velocityModal,
      cartExpired: (state) => state.cart.cartExpired
    })
  },
  methods: {
    ...mapMutations({
      updateStep: 'checkout/updateStep',
      setVelocityModal: 'checkout/setVelocityModal'
    }),
    ...mapActions({
      initSession: 'session/init',
      getOrder: 'checkout/getOrder',
      abandonCheckout: 'checkout/abandonCheckout'
    }),
    goToPayment() {
      window.location = '/checkout/payment'
    },
    reset() {
      this.abandonCheckout().then(() => {
        window.location = checkoutSettings.abandonCartURL;
      })
    }
  },
  async mounted() {
    await this.initSession();

    this.updateStep('payment')

    await this.getOrder()

    switch (this.order.state.value) {
      case OrderStates.PAYMENT_PENDING:
      case OrderStates.COMPLETED: // TODO: Redirect if customer ends up here in completed state?
        this.tryAgain = true;
        break;
      case OrderStates.VELOCITY_CHECK_FAILED:
        this.setVelocityModal(true);
        break;
    }
    
    if(this.order && this.order.customer && this.order.customer.email)
      paymentFailedKlaviyo(this.order, this.order.customer.email, 'PAYMENT_UNSUCCESSFUL');  
  }
}
</script>
